var map = {
	"./体育.svg": 3684,
	"./劳动实践.svg": 7057,
	"./地理.svg": 1260,
	"./学校办学质量.svg": 2016,
	"./学生入口.svg": 5594,
	"./学生管理.svg": 6376,
	"./学生综合信息.svg": 6516,
	"./学生自评.svg": 4194,
	"./幼儿园管理.svg": 560,
	"./教学.svg": 5893,
	"./教育.svg": 6771,
	"./机构.svg": 7947,
	"./生涯.svg": 9862,
	"./生物.svg": 2247,
	"./选课.svg": 1032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;